var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('v-toolbar',{attrs:{"flat":"","dense":""}},[_c('div',{staticClass:"subtitle-2"},[_vm._v("Transfers")]),_c('v-spacer'),_c('Download',{attrs:{"items":_vm.items,"year":_vm.year,"total":_vm.total}})],1),_c('Table',{attrs:{"items":_vm.items,"total":_vm.total}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }